export default __webpack_public_path__ + "static/media/SG17.bc06161a.webp";